export const CONTRACT_STEPS = ["Formulário", "Signatários"];
